<template>
	<div class="page-wrapper">
		<div class="page-content">
			<div class="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
				<div class="breadcrumb-title pe-3">Career Details Page CMS</div>
				<div class="ps-3">
					<nav aria-label="breadcrumb">
						<ol class="breadcrumb mb-0 p-0">
							<li class="breadcrumb-item">
								<router-link to="/dashboard">
									<i class="bx bx-home-alt"></i>
								</router-link>
							</li>
							<li class="breadcrumb-item active" aria-current="page">Career Details Page CMS</li>
						</ol>
					</nav>
				</div>
			</div>
			<form @submit.prevent="updateCms()">
				<div class="card">
					<div class="card-body">
						<h5 class="card-title">Career Details Page CMS</h5>
						<hr />
						<div class="form-body mt-4">
							<div class="row">
								<div class="col-lg-12 mb-3">
									<div class="border border-3 p-4 rounded">
										<div class="row">
											<div class="col-6 mb-3">
												<label class="form-label">More Job Section Title:</label>
												<input type="text" v-model="cmsData.moreJobsSectionTitle" class="form-control" id="inputPageHeaderTitle" placeholder="Enter more job section title" />
											</div>
											<div class="col-6 mb-3">
												<label class="form-label">More Job Section Subtitle:</label>
												<input type="text" v-model="cmsData.moreJobsSectionSubTitle" class="form-control" id="inputPageHeaderTitle" placeholder="Enter more job section subtitle"/>
											</div>
											<div class="col-6 mb-3">
												<label class="form-label">Why Join Us Section Title:</label>
												<input type="text" v-model="cmsData.whyJoinUsSectionTitle" class="form-control" id="inputPageHeaderTitle" placeholder="Enter why join us section title"/>
											</div>
											<div class="col-6 mb-3">
												<label class="form-label">Why Join Us Section Subtitle:</label>
												<input type="text" v-model="cmsData.whyJoinUsSectionSubTitle" class="form-control" id="inputPageHeaderTitle" placeholder="Enter why join us section subtitle"/>
											</div>
											<div class="col-6 mb-3">
												<div class="row">
													<div class="col-12">
														<label for="inputProductTitle" class="form-label">
															Logo: <strong>[Preferred Image Size: 140X50, Max Upload Limit: 1MB]</strong>
														</label>
													</div>
													<div class="col-12">
														<input class="form-control mt-3" type="file" ref="backgroundImage1" accept="image/*" @change="handleUploadImage('logo','imageOne','backgroundImage1', $event)"/>
													</div>
												</div>
												<div class="mt-3">
													<img style="position: relative; left: 11px" v-if="preview.imageOne" :src="preview.imageOne" />
													<img style="position: relative; left: 11px" v-else-if="cmsData.logo" :src="cmsData.logo"/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="d-grid">
									<button type="submit" class="btn btn-primary">Save</button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</form>
		</div>
	</div>
</template>

<script src="../js/career-details-page-cms.js"></script>